import Card from "@rio-cloud/rio-uikit/Card";
import DRERow from "./DRERow";
import type { DashboardFilter, DREHierarchicalLine, DRELineType, DRENodeType, DREParentPath } from "../../../types/dashboard";
import DownloadButton from "./downloadButton";
import DREDate from "../DREDate";
import { useState } from "react";

export interface ExpandNodeParams {
  nodeId: string;
  compositeId: string;
  nodeType: DRENodeType;
  lineType: DRELineType;
  parentPath?: DREParentPath;
}

interface DRETableProps {
  data: DREHierarchicalLine[];
  expandedItems: string[];
  loadingNodes: string[];
  requestFilters?: DashboardFilter
  onToggle: (id: string) => void;
  onExpandNode: (params: ExpandNodeParams) => Promise<void>;
  onDownload?: () => void;
}

export default function DRETable({ data, expandedItems, loadingNodes, requestFilters, onToggle, onExpandNode, onDownload }: DRETableProps) {
  const [hoveredId, setHoveredId] = useState('');

  return (
    <Card className="padding-y-20 padding-x-50 margin-bottom-20">
      <div className="display-flex align-items-center justify-content-between gap-10 padding-bottom-20">
        <span className="text-size-16 text-bold">DRE (Demonstrativo de Resultado do Exercício)</span>
        {/* <DownloadButton
          items={[
            {
                icon: "rioglyph rioglyph-search-list ",
                onClick: () => console.log('clicou'),
                title: 'Visão geral'
            },
            {
                icon: "rioglyph rioglyph-building",
                onClick: () => console.log('clicou'),
                title: 'Regional'
            },
            {
                icon: "rioglyph rioglyph-role-management",
                onClick: () => console.log('clicou'),
                title: 'Segmento'
            },
            {
                icon: "rioglyph rioglyph-truck",
                onClick: () => console.log('clicou'),
                title: 'Veículo'
            },
            {
                icon: "rioglyph rioglyph-driver",
                onClick: () => console.log('clicou'),
                title: 'Motorista'
            },
          ]}
        /> */}
      </div>
      <div className="display-flex justify-content-end padding-right-25 border border-bottom-only">
        <div className="width-150  display-flex justify-content-end">
          <p className="margin-right-10">Previsão</p>
        </div>
        <div className="width-150  display-flex justify-content-end">
          <p className="margin-right-10">Comprometido</p>
        </div>
        <div className="width-150  display-flex justify-content-end">
          <p className="margin-right-10">Realizado</p>
        </div>
        <div className="width-150 display-flex justify-content-end">
          <p className="margin-right-10">Previsto X Realizado</p>
        </div>
      </div>

      {data.map((item, index) => (
        <DRERow
          item={item}
          key={item.compositeId ?? item.id}
          lineType={item.lineType}
          onToggle={onToggle}
          expandedItems={expandedItems}
          loadingNodes={loadingNodes}
          onExpandNode={onExpandNode}
          isLast={index === data.length - 1}
          depth={item.level}
          hoveredId={hoveredId}
          setItemId={(id) => setHoveredId(id)}
        />
      ))}

      <DREDate requestFilters={requestFilters} />
    </Card>
  );
}
